<ag-grid-angular
#cxoneOrderManagementGrid
*ngIf="orderManagementGridOptions"
[gridOptions]="orderManagementGridOptions"
[getRowHeight]="getRowHeight"
class="ag-theme-balham flex-fill border-0 d-block w-100 h-100"
>
</ag-grid-angular>
